import {isShopScoped} from '../../common/stockScope'
import {useEffect, useState, useRef} from 'react' // Added useRef back
import {UserModel} from '../../auth'
import {getStockQtyInfo} from '../core/_requests'
import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {IStockQtyBody} from '../core/_models'
import {Tooltip} from 'bootstrap' // Added Tooltip import back

type Props = {
  className: string
  language: string
  currentUser: UserModel | undefined
}

const StockQtyCard: React.FC<Props> = ({language, currentUser, className}) => {
  const {formatMessage} = useIntl()
  const [state, setState] = useState<IStockQtyBody>({
    stock_quantity: '0',
    info: '', // Added info field back
    stock_scope: 'national',
  })
  const [loading, setLoading] = useState<boolean>(true) // Added loading state
  const tooltipTriggerRef = useRef<HTMLSpanElement | null>(null) // Added tooltipTriggerRef back

  useEffect(() => {
    const getData = async () => {
      setLoading(true) // Set loading true at the start
      try {
        const {data} = await getStockQtyInfo(currentUser?.token, language)
        if (data?.data) {
          // Check if data and data.data exist
          setState({
            stock_quantity: data.data.stock_quantity || '0', // Provide fallback
            info: data.data.info || '', // Added info assignment back
            // "shop" for a partner shop's account: the total is its store shelf.
            stock_scope: data.data.stock_scope || 'national',
          })
        } else {
          console.log('API Response - data or data.data missing')
          setState({stock_quantity: '0', info: '', stock_scope: 'national'}) // Reset state on unexpected response
        }
      } catch (error) {
        console.error('Error fetching stock quantity data:', error)
        setState({stock_quantity: '0', info: '', stock_scope: 'national'}) // Reset state on error
      } finally {
        setLoading(false) // Set loading false when done
      }
    }
    getData()
  }, [currentUser, language]) // Added dependencies

  // Added tooltip initialization useEffect back
  useEffect(() => {
    if (tooltipTriggerRef.current && state.info) {
      // Check if ref exists and info has text
      const tooltip = new Tooltip(tooltipTriggerRef.current, {
        trigger: 'hover', // Or 'click', 'focus'
      })
      // Optional: Handle tooltip disposal on component unmount
      return () => {
        tooltip.dispose()
      }
    }
  }, [state.info]) // Re-initialize if info text changes

  return (
    <div className={`hsb-card hsb-card--tertiary ${className}`}>
      <div>
        <div className='hsb-card-head'>
          <span className='hsb-chip hsb-chip--tertiary'>
            <span className='material-symbols-outlined'>inventory_2</span>
          </span>
        </div>
        <span className='hsb-kpi-label'>
          {formatMessage({id: isShopScoped(state) ? 'shop_scope.stock_total_on_shelf' : 'stock_total_qty'})}
          <span // Wrap icon in a span for the ref
            ref={tooltipTriggerRef}
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            data-bs-custom-class='tooltip-light'
            title={state.info} // Use state for title
          >
            <i className='fas fa-info-circle hsb-info-icon'></i>
          </span>
        </span>
        <h2 className='hsb-kpi-value hsb-kpi-value--display hsb-kpi-value--tertiary'>{state.stock_quantity}</h2>
      </div>

      <Link to='/stock-report' className='hsb-link hsb-link--tertiary'>
        {formatMessage({ id: "view_prods" })}
        <span className='material-symbols-outlined'>arrow_forward</span>
      </Link>
    </div>
  )
}

export default StockQtyCard
